import { filterNames } from '@/configuration/components/Filters/constants'

const matchDeliveryMethodName = (deliveryMethod, filterValue, t, deliveryMethodLabels) => {
  const deliveryMethodNames = Object.values(deliveryMethod?.name || {}).filter(name => name)
  const defaultName = t(deliveryMethodLabels[deliveryMethod?.type])

  const includeCustomName = deliveryMethodNames.some(name => name.toLowerCase().includes(filterValue.toLowerCase()))
  const includeDefaultName = defaultName.toLowerCase().includes(filterValue.toLowerCase())

  return includeCustomName || includeDefaultName
}

export const filterDeliveryMethods = (deliveryMethods, filters, t, deliveryMethodLabels) => {
  const filterKeys = Object.keys(filters)
  if (filterKeys.length === 0) return deliveryMethods

  return deliveryMethods.filter(deliveryMethod => {
    return filterKeys.every(filterName => {
      const filterValue = filters[filterName]

      if (filterName === filterNames.region) {
        const regionsIds = deliveryMethod?.regions?.flatMap(region => [
          region.id,
          ...(region?.provinces?.map(province => province.id) || []),
        ])

        return regionsIds?.some(id => filterValue.includes(id))
      }

      if (filterName === filterNames.deliveryMethod) {
        return filterValue?.includes(deliveryMethod.type)
      }

      if (filterName === filterNames.query && filterValue.length > 0) {
        return matchDeliveryMethodName(deliveryMethod, filterValue, t, deliveryMethodLabels)
      }

      if (filterName === filterNames.carrierService) {
        return deliveryMethod?.carrier_service?.id === filterValue
      }

      return true
    })
  })
}
